import { render, staticRenderFns } from "./TableLicensesExpiring.vue?vue&type=template&id=718d4ad8&"
import script from "./TableLicensesExpiring.vue?vue&type=script&lang=js&"
export * from "./TableLicensesExpiring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports